import axios from '../util/request'
const md5 = require('js-md5')
const stamp = Date.now()

// 资源分类列表
export const resourceClassList = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.father_id}${stamp}${atob(localStorage.getItem('okey'))}`) 
  return axios.get('/api/xiaosen/user/info/resourceClassList', {
    params: { ...data }
  })
}

// 资源分类信息
export const resourceClassInfo = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.id}${stamp}${atob(localStorage.getItem('okey'))}`) 
  return axios.get('/api/xiaosen/user/info/resourceClassInfo', {
    params: { ...data }
  })
}

// 资源列表
export const resourceList = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.user_id}${data.class_id}${stamp}${atob(localStorage.getItem('okey'))}`) 
  return axios.get('/api/xiaosen/user/info/resourceList', {
    params: { ...data }
  })
}

// 资源信息
export const resourceInfo = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.user_id}${data.id}${stamp}${atob(localStorage.getItem('okey'))}`) 
  return axios.get('/api/xiaosen/user/info/resourceInfo', {
    params: { ...data }
  })
}




